var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import StatementItemTypes from "@irati/wallet/types/enums/StatementItemTypes";
import PerksGOCashback from "./PerksGO/Cashback";
import Spend from "./Spend";
import ManualCredit from "./ManualCredit";
import SendCreditAsReward from "./SendCreditAsReward";
import UseCreditToBuyReward from "./UseCreditToBuyReward";
import TopUp from "./TopUp";
import TransferToRewardsWallet from "./TransferToRewardsWallet";
import RefundFromRewardsWallet from "./RefundFromRewardsWallet";
import SendCredit from "./SendCredit";
import ManualRefund from "./ManualRefund";
var StatementItemClass = /** @class */ (function (_super) {
    __extends(StatementItemClass, _super);
    function StatementItemClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatementItemClass.prototype.render = function () {
        var _a = this.props, className = _a.className, statementItem = _a.statementItem, isRewardWallet = _a.isRewardWallet, isTenantWallet = _a.isTenantWallet;
        var type = statementItem.transfer.type;
        switch (type) {
            case StatementItemTypes.PERKS_GO_CASHBACK: {
                var idNamespace = id("perks-go-cashback", this.props);
                return React.createElement(PerksGOCashback, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.SPEND: {
                var idNamespace = id("spend", this.props);
                return React.createElement(Spend, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.MANUAL_CREDIT: {
                var idNamespace = id("manual-credit", this.props);
                return React.createElement(ManualCredit, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.SEND_CREDIT_AS_REWARD: {
                var idNamespace = id("send-credit-as-reward", this.props);
                return React.createElement(SendCreditAsReward, { id: idNamespace, className: className, isRewardWallet: isRewardWallet, statementItem: statementItem });
            }
            case StatementItemTypes.USE_CREDIT_TO_BUY_REWARD: {
                var idNamespace = id("use-credit-to-buy-reward", this.props);
                return React.createElement(UseCreditToBuyReward, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.TRANSFER_TO_REWARDS_WALLET: {
                var idNamespace = id("transfer-to-rewards-wallet", this.props);
                return (React.createElement(TransferToRewardsWallet, { id: idNamespace, isTenantWallet: isTenantWallet, className: className, statementItem: statementItem }));
            }
            case StatementItemTypes.NEW_TOP_UP_BANK_TRANSFER:
            case StatementItemTypes.TOP_UP_BANK_TRANSFER: {
                var idNamespace = id("topup-bank-transfer", this.props);
                return React.createElement(TopUp, { id: idNamespace, isBankTransfer: true, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.NEW_TOP_UP_CARD_PAYMENT:
            case StatementItemTypes.TOP_UP_CARD_PAYMENT: {
                var idNamespace = id("topup-card-payment", this.props);
                return React.createElement(TopUp, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.REFUND_FROM_REWARDS_WALLET: {
                var idNamespace = id("refund-from-rewards-wallet", this.props);
                return (React.createElement(RefundFromRewardsWallet, { id: idNamespace, isTenantWallet: isTenantWallet, className: className, statementItem: statementItem }));
            }
            case StatementItemTypes.SEND_CREDIT: {
                var idNamespace = id("send-credit", this.props);
                return React.createElement(SendCredit, { id: idNamespace, className: className, statementItem: statementItem });
            }
            case StatementItemTypes.MANUAL_REFUND: {
                var idNamespace = id("manual-refund", this.props);
                return React.createElement(ManualRefund, { id: idNamespace, className: className, statementItem: statementItem });
            }
            default: {
                return null;
            }
        }
    };
    StatementItemClass.defaultProps = {
        className: null,
        isRewardWallet: false,
        isTenantWallet: false
    };
    return StatementItemClass;
}(PureComponent));
export default StatementItemClass;
